/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_Backup_Select_Folder_LabelInputs */

const en_options_backup_select_folder_label = /** @type {(inputs: Options_Backup_Select_Folder_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Select target backup folder`)
};

const fr_options_backup_select_folder_label = /** @type {(inputs: Options_Backup_Select_Folder_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sélectionner le dossier de sauvegarde cible`)
};

const de_options_backup_select_folder_label = /** @type {(inputs: Options_Backup_Select_Folder_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ziel-Sicherungsordner auswählen`)
};

const it_options_backup_select_folder_label = /** @type {(inputs: Options_Backup_Select_Folder_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seleziona la cartella di backup di destinazione`)
};

const ru_options_backup_select_folder_label = /** @type {(inputs: Options_Backup_Select_Folder_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Выберите целевую папку для резервного копирования.`)
};

const es_options_backup_select_folder_label = /** @type {(inputs: Options_Backup_Select_Folder_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seleccionar la carpeta de respaldo de destino`)
};

const zh_cn2_options_backup_select_folder_label = /** @type {(inputs: Options_Backup_Select_Folder_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`选择目标备份文件夹`)
};

const ja_options_backup_select_folder_label = /** @type {(inputs: Options_Backup_Select_Folder_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`バックアップ先のフォルダを選択`)
};

const hi_options_backup_select_folder_label = /** @type {(inputs: Options_Backup_Select_Folder_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`लक्ष्य बैकअप फ़ोल्डर का चयन करें`)
};

const pt_pt2_options_backup_select_folder_label = /** @type {(inputs: Options_Backup_Select_Folder_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Selecione a pasta de backup de destino.`)
};

/**
* | output |
* | --- |
* | "Select target backup folder" |
*
* @param {Options_Backup_Select_Folder_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_backup_select_folder_label = /** @type {((inputs?: Options_Backup_Select_Folder_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Backup_Select_Folder_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_options_backup_select_folder_label(inputs)
	if (locale === "de") return de_options_backup_select_folder_label(inputs)
	if (locale === "it") return it_options_backup_select_folder_label(inputs)
	if (locale === "ru") return ru_options_backup_select_folder_label(inputs)
	if (locale === "es") return es_options_backup_select_folder_label(inputs)
	if (locale === "zh-CN") return zh_cn2_options_backup_select_folder_label(inputs)
	if (locale === "ja") return ja_options_backup_select_folder_label(inputs)
	if (locale === "hi") return hi_options_backup_select_folder_label(inputs)
	if (locale === "pt-PT") return pt_pt2_options_backup_select_folder_label(inputs)
	return en_options_backup_select_folder_label(inputs)
});